import { Component, inject } from "@angular/core";
import { ModalService } from "../../shared/services/modal.service";
import { ModalAdminTagComponent } from "./modal-admin-tag/modal-admin-tag.component";
import { AdminService } from "../../shared/services/admin.service";
import { empty } from "../../functions";
import { Subject } from "rxjs";
import {
  alertMessages,
  AlertService,
} from "../../shared/services/alert.service";
import { catchError } from "rxjs/operators";
import { Tag } from "../../api/models/tag";

@Component({
  selector: "app-admin-tags",
  templateUrl: "./admin-tags.component.html",
  standalone: false,
})
export class AdminTagsComponent {
  readonly modal = inject(ModalService);
  readonly adminService = inject(AdminService);
  private readonly alertService = inject(AlertService);
  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Name",
        name: "name",
        type: "text",
      },
    ],
    endpoint: "tag",
    data: [] as Tag[],
    buttons: [
      {
        class: "btn btn-danger",
        event: "delete",
        text: "Delete",
      },
      {
        class: "btn btn-warning",
        event: "edit",
        text: "Edit",
      },
    ],
    class: "",
    reloadListener: new Subject(),
  };

  addTag() {
    const modalOptions = {
      backdrop: "static",
      size: "md",
    };

    const data = {
      entity: {
        id: "",
        name: "",
      },
    };

    this.modal
      .Modal(ModalAdminTagComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.alertService.success(alertMessages.successDataSaved);
          this.configTable.reloadListener.next(true);
        }
      })
      .catch(() => {
        /* modal dismissed */
      });
  }

  updateTag($data: Tag) {
    const modalOptions = {
      backdrop: "static",
      size: "md",
    };

    const data = {
      entity: $data,
    };

    this.modal
      .Modal(ModalAdminTagComponent, "", "", data, [], modalOptions)
      .then((result) => {
        if (result === true) {
          this.alertService.success(alertMessages.successDataSaved);
          this.configTable.reloadListener.next(true);
        }
      })
      .catch(() => {
        /* modal dismissed */
      });
  }

  deleteTag(id: string) {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.adminService
            .apiDeleteTag(id)
            .pipe(
              catchError(this.adminService.handleError("apiDeleteTag", false))
            )
            .subscribe((result) => {
              if (result !== false) {
                this.alertService.success(alertMessages.successDataRemoved);
                this.configTable.reloadListener.next(true);
              }
            });
        }
      })
      .catch(() => {
        /* modal dismissed */
      });
  }

  handleButtonEvent($event: { event: string; data: Tag }) {
    if (!empty($event["event"])) {
      switch ($event["event"]) {
        case "edit":
          this.updateTag($event["data"]);
          break;

        case "delete":
          this.deleteTag($event["data"]["id"]!);
          break;
      }
    }
  }
}
